import { routesNames } from '@/core/constants'
import PesquisaAtaView from '@/views/pages/ata/pesquisa/PesquisaAtaView.vue'
import Acessar from '@/views/pages/ata/pesquisa/acessar/AcessarAtaView.vue'

export default [
	{
		name: routesNames.ATA.ATA_VIEW,
		path: '/atas',
		component: PesquisaAtaView,
		meta: {
			title: 'Ata',
		},
	},
	{
		name: routesNames.ATA.ATA_ACESSAR_VIEW,
		path: '/atas/informacoes/:id',
		component: Acessar,
		meta: {
			page: {
				title: 'Informações da ata',
			},
		},
	},
]
